import "./index.scss";

import { ReactComponent as InstructorSwitchIcon } from "../../../assets/images/square-buttons/instructor-switch.svg";
import { ReactComponent as SwitchIcon } from "../../../assets/images/square-buttons/status-switch.svg";
import { ReactComponent as TrashIcon } from "../../../assets/images/square-buttons/trash.svg";

const ActionButtons = (props) => {
  return (
    <div className={"action-buttons-container"}>
      <button className={"switch-icon"} onClick={props.onMassStatusSwitchClick}>
        <SwitchIcon />
        <span>Mass Status Switch</span>
      </button>
      <button
        className={"instructor-switch-icon"}
        onClick={() => props.onMassInstructorSwitchClick()}
      >
        <InstructorSwitchIcon />
        <span>Mass Instructor Switch</span>
      </button>
      <button className={"trash-icon"} onClick={props.onMassDeleteClick}>
        <TrashIcon />
        <span>Mass Delete</span>
      </button>
    </div>
  );
};

export default ActionButtons;
